module.exports = __webpack_public_path__ + "static/media/mail_icon_open@3x.de9375fb.png";